export const AUDIT = 
{
    Metadata:{Name:'AUDIT',maxColumn:5,numRows:10},
    Sections:
    [
        {
            Headers:[
                "Beer, wine, and liquor are typical alcoholic beverages. " + 
                "A drink typically means a 12-ounce can or bottle of beer, a 5 ounce glass of wine," +
                "a 12 ounce wine cooler, or a 1.5 ounce shot of liquor served straight or in a mixed drink. " + 
                "<span class='importantText'>In the past 12 months...</span>",
                "Never",
                "Monthly or less",
                "2-4 Times a Month",
                "2-3 Times a Week",
                "4 or More Times a Week"
            ],
            Questions:[
                {
                    Prompt:"1. How often do you have a drink containing alcohol",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:4,Type:"radio"}
                    ]
                },
            ]
        },
        {
            Headers:[
                "",
                "1 or 2",
                "3 or 4",
                "5 or 6",
                "7 or 9",
                "10 or more"
            ],
            Questions:[
                {
                    Prompt:"2. How many drinks containing alcohol do you have on a typical day when you are drinking?",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:4,Type:"radio"}
                    ]
                },
            ]
        },
        {
            Headers:[
                "",
                "Never",
                "Less then Monthly",
                "Monthly",
                "Weekly",
                "Daily or Almost Daily"
            ],
            Questions:[
                {
                    Prompt:"3. For women: How often do you have 4 or more drinks on one occasion? For men: How often do you have 5 or more drinks on one occasion?",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:4,Type:"radio"}
                    ]
                },
                {
                    Prompt:"4. How often during the last year have you found that you were not able to stop drinking once you had started?",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:4,Type:"radio"}
                    ]
                },
                {
                    Prompt:"5. How often during the last year have you failed to do what was normally expected of you because of drinking?",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:4,Type:"radio"}
                    ]
                },
                {
                    Prompt:"6. How often during the last year have you needed a first drink in the morning to get yourself going after a heavy drinking session?",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:4,Type:"radio"}
                    ]
                },
                {
                    Prompt:"7. How often during the last year have you had a feeling of guilt or remorse after drinking?",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:4,Type:"radio"}
                    ]
                },
                {
                    Prompt:"8. How often during the last year have you been unable to remember what happened the night before because of your drinking",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:4,Type:"radio"}
                    ]
                },
            ]
        },
        {
            Headers:[
                "",
                "No",
                "Yes, but not in the last year",
                "Yes, During the last year"
            ],
            Questions:[
                {
                    Prompt:"9. Have you or someone else been injured because of your drinking?",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:4,Type:"radio"},
                    ]
                },
                {
                    Prompt:"10. Has a relative, friend, doctor, or other health care worker been concerned about your drinking or suggested you cut down?",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:4,Type:"radio"},
                    ]
                },
            ]
        },
    ]
}